import StatutesPage from "./StatutesPage";

export default StatutesPage;
